import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-dialog-login',
  templateUrl: 'dialog-login.html',
})
export class DialogLoginComponent {

  constructor(
    public dialogRef: MatDialogRef<DialogLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    //
  }

  select(result: string): void {
    this.dialogRef.close(result);
  }

}

export interface DialogData {
  title: string;
  message: string;
  confirmation: string;
}
